'use strict';

// external
import {keys} from 'ts-transformer-keys';
import {Message} from '~/shared/src/utilities/message';
import {Style} from '~/shared/src/utilities/style';
import {Action} from '~/shared/src/utilities/action';
import {Condition} from '~/shared/src/utilities/condition';

/*** MetaModel types *************************************************************************************************/

export type Visibility = 'visible' | 'hidden' | 'hiddenIfLeave';

// CFG:TreeNode
export type TreeNode = {
    type : 'TreeNode';
    uniqueId : string;
    data : {
        id : number;
        key : string;
        name? : string;

        disableDeleteDescendantReferences : boolean;
        disableDeleteDescendantItems : boolean;
        iconClass? : string;
        openExpanded : boolean;
        order? : number;
        stopLoading : boolean;
        visibility : Visibility;
    };
    referenceData : {
        id : number;

        order? : number;
    };
    customButtonConfig? : {
        icon? : string;
        label? : Message;
        panelConfigIds : number[]
    };
    nodes? : ( TreeNode | DynamicNode )[];
    messages? : {
        label? : Message;
    };
    images? : {
        icon? : string;
    };
    styles? : {
        style? : Style[];
    };
};
export const treeNodeDataProps = keys<TreeNode['data']>();
export const treeNodeReferenceDataProps = keys<TreeNode['referenceData']>();
export const treeNodeImages = keys<Required<TreeNode>[ 'images' ]>() as string[];
export const treeNodeMessages = keys<Required<TreeNode>[ 'messages' ]>() as string[];
export const treeNodeStyles = keys<Required<TreeNode>[ 'styles' ]>() as string[];
export const requiredTreeNodeProps = keys<RequiredOf<TreeNode>>();
export const treeNodeProps = keys<TreeNode>();

// CFG:DynamicNode
export type DynamicNode = {
    type : 'DynamicNode';
    uniqueId : string;
    data : {
        id : number;
        key : string;
        name? : string;

        disableAddExistingItem : boolean;
        disableAddNewItem : boolean;
        disableDeleteDescendantItems : boolean;
        disableDeleteDescendantReferences : boolean;
        disableDeleteItem : boolean;
        disableDeleteReference : boolean;
        grouping? : string; // TODO: enum?
        iconClass? : string;
        ignoreDirtyMark : boolean;
        isDraggable : boolean;
        isDropTarget : boolean;
        openExpanded : boolean;
        order? : number;
        orderBy? : string;
        readOnly : boolean;
        stopLoading : boolean;
        visibility : Visibility;
    };
    referenceData : {
        id : number;

        order? : number;
    };
    dataObjectIds? : number[];
    customButtonConfig? : {
        icon? : string;
        label? : Message;
        panelConfigIds : number[]
    }
    nodes? : ( TreeNode | DynamicNode )[];
    actions? : Action[];
    conditions? : {
        disablingAddExistingItem? : Condition;
        disablingAddNewItem? : Condition;
        disablingDeleteItem? : Condition;
        disablingDeleteReference? : Condition;
        filter? : Condition;
    };
    messages? : {
        label? : Message;
    };
    images? : {
        icon? : string;
    };
    styles? : {
        style? : Style[];
    };
};
export const dynamicNodeDataProps = keys<DynamicNode['data']>();
export const dynamicNodeReferenceDataProps = keys<DynamicNode['referenceData']>();
export const dynamicNodeConditions = keys<Required<DynamicNode>[ 'conditions' ]>() as string[];
export const dynamicNodeImages = keys<Required<DynamicNode>[ 'images' ]>() as string[];
export const dynamicNodeMessages = keys<Required<DynamicNode>[ 'messages' ]>() as string[];
export const dynamicNodeStyles = keys<Required<DynamicNode>[ 'styles' ]>() as string[];
export const requiredDynamicNodeProps = keys<RequiredOf<DynamicNode>>();
export const dynamicNodeProps = keys<DynamicNode>();
